<script setup lang="ts">
import { DateFormat, SemboDate } from '@libs/sembo-dates';
import { AppSvgIcon } from '@libs/ui';

interface DealCodeTagProps {
  wrap?: boolean;
  type?: 'tag';
}

const props = withDefaults(defineProps<DealCodeTagProps>(), { wrap: false });

const now = new Date();
const effectiveDate = new SemboDate(
  '05-06-2025 09:00',
  DateFormat.FullDateTime
);
const shouldApplySummerDealCode = effectiveDate.isBefore(now);
const dealCode = shouldApplySummerDealCode ? 'Summer2025' : 'Spring2025';
</script>

<template>
  <div
    class="deal-code-tag"
    :class="{ wrap: props.wrap, tag: props.type === 'tag' }"
  >
    <div class="label">
      <AppSvgIcon name="priceLabel" size="18" />
      <span class="deal-code-text">{{ $t('planner.with_code') }}:</span>
    </div>
    <div class="deal-name">{{ dealCode }}</div>
  </div>
</template>

<style scoped lang="scss">
.deal-code-tag {
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  justify-content: flex-end;
  color: var(--color-neutral-70);
  @include font-label-s-bold;

  &.wrap {
    flex-wrap: wrap;
  }
  .label {
    display: flex;
    align-items: center;
    gap: var(--spacing-4);
  }

  &.tag {
    flex-direction: column;
    align-items: flex-start;

    .deal-name {
      background-color: var(--color-brand-summer);
      border-radius: var(--border-radius-8);
      padding: var(--spacing-4);
    }
  }

  .deal-code-text {
    text-align: right;
    white-space: nowrap;
    @include font-label-s-light;
  }
}
</style>
